export default function initPopup() {
    const popupContentAll = document.querySelectorAll('.popup__content');
    const shadowBox = document.querySelector('.popup__bg');
    const buttonPopups = document.querySelectorAll('.popup__run');

    const runPopup = function(formId, blockId) {
        if(formId && blockId) {
            var popupContentBox = document.querySelector('.popup__content.popup-' + formId + '.popup-block-id-' + blockId);
        } else {
            var popupContentBox = document.querySelector('.popup__content');
        }
        if (popupContentBox) {
            showPopup(popupContentBox);
        }
    }


    const showPopup = function(popupContentBox) {
        popupContentBox.classList.add('active');
        shadowBox.classList.add('active');
        new SimpleBar(document.querySelector('.popup__content.active .popup-inner'), {
            autoHide: false
        });

    }

    const hidePopup = function() {
        popupContentAll.forEach(function(i) {
            i.classList.remove('active');
        });
        shadowBox.classList.remove('active');
    }

    buttonPopups.forEach(function(i) {
        i.addEventListener('click', function(e) {
            e.preventDefault();
            runPopup(i.dataset.formId, i.dataset.blockId);
        });
    });

    if(document.querySelector('.popup__bg')) {
        document.querySelector('.popup__bg').addEventListener('click', function(e) {
            e.preventDefault();
            hidePopup();
        });
    }

    document.querySelectorAll('.popup__close').forEach(function(item) {
        item.addEventListener('click', function(e) {
            e.preventDefault();
            hidePopup();
        });
    });
}
